import getCustomEnUsLocale from './getCustomEnUsLocale';

function getDefaultDateFnsLocale() {
  return getCustomEnUsLocale();
}

export default getDefaultDateFnsLocale;
